import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {getJourneyAction} from '@/services/loyalty/loyaltyUtils';
import {selectAllJourneys} from '@/state/selectors/consumerLoyalty';
import {LoyaltyActionInfoType} from '@/types/loyalty';

export const useJourneyLevelAction = (actionInfo?: LoyaltyActionInfoType) => {
    const journeys = useSelector(selectAllJourneys);

    return useMemo(() => {
        if (!actionInfo) {
            return null;
        }

        return getJourneyAction(journeys, actionInfo) || null;
    }, [actionInfo]);
};
